module.exports = __webpack_public_path__ + "spatial-tag-link.76a64f3adf33b805f977e99c1fb5b778.svg";